import React from 'react'
import CampaignForm from 'pages/ArcCampaigns/CampaignForm'

const ArcCampaignModal = ({ closeModal, campaign, callback }) => {
  const handleSubmit = () => {
    closeModal()
    if (callback) {
      callback()
    }
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <CampaignForm
      campaign={campaign}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  )
}

export default ArcCampaignModal